export default "__VITE_ASSET__00e79b40__"